class AlertBar {
  constructor() {
    this.initComponents()
    this.bindEvents()
  }

  initComponents() {
    this.container = document.querySelector("[data-sitewide-alert-container]")
    this.readMoreButton = document.querySelector("[data-sitewide-alert-read-more]")
    this.closeButton = document.querySelector("[data-sitewide-alert-close]")
  }

  bindEvents() {
    if (this.readMoreButton) {
      this.readMoreButton.addEventListener("click", () => {
        this.setFilesToRead()
      })
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", event => {
        event.preventDefault()
        this.close()
      })
    }
  }

  /**
   * Visiting pages appends ?alert-read=true which is handled by PageController
   * This request is to also tell the server when we've visited files
   */
  setFilesToRead() {
    // send request
    var xhr = new XMLHttpRequest()
    xhr.open("GET", window.location.origin + "/alert/read")
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
    xhr.send()
  }

  close() {
    // send request
    var xhr = new XMLHttpRequest()
    xhr.open("GET", this.closeButton.href)
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
    xhr.onload = () => this.hideBar(xhr.status, xhr.response)
    xhr.send()
  }

  hideBar(status, response) {
    if (status == 200) {
      this.container.style.maxHeight = 0
    } else {
      // eslint-disable-next-line no-console
      console.error(response)
    }
  }
}

export default function init() {
  new AlertBar()
}
